import {inject, bindable, bindingMode} from 'aurelia-framework';

@inject(Element)
export class ValidationMessage {

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) maxWidth;

  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) visible = false;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) triggerElement = null;

  constructor(private __el: Element) {
  }
  attached() {
    console.log('attached');
    if (this.visible) {
      this.__el.classList.add('visible');
      setTimeout(()=>{
        this.__el.classList.remove('visible');
        this.visible = false;
      }, 4000);
    }
  }

  get style() {
    return this.maxWidth ? `max-width: ${this.maxWidth};` : '';
  }


}
